<template>
  <div class="panel panel-default agency--panel">
    <div class="panel-body menu__panel-body">
      <div class="col-md-12">
        <button
          id="agency-management-refresh-button"
          class="btn btn-raised button__toolbar"
          :disabled="!refreshEnabled"
          @click="emitUserSearch(), emitTriggerReload()"
        >
          <i class="material-icons md-36">refresh</i>
          <br />
          {{ lang.AM1000 }}
        </button>
        <button
          id="agency-management-create-button"
          class="btn btn-raised button__toolbar"
          v-if="globals.isAccessAllowed('LoopOp_Agencies_Create')"
          @click="emitEditAgency(true)"
        >
          <i class="material-icons md-36">add_box</i>
          <br />
          {{ lang.AM1002 }}
        </button>
        <button
          id="agency-management-edit-button"
          class="btn btn-raised button__toolbar"
          v-if="globals.isAccessAllowed('LoopOp_Agencies_Read')"
          :disabled="!agencySelected"
          @click="emitEditAgency(false)"
        >
          <i class="material-icons md-36">edit</i>
          <br />
          {{ lang.AM1003 }}
        </button>
        <button
          id="agency-management-delete-button"
          class="btn btn-raised button__toolbar"
          v-if="globals.isAccessAllowed('LoopOp_Agencies_Delete')"
          :disabled="!agencySelected"
          @click="emitDeleteAgency()"
        >
          <i class="material-icons md-36">clear</i>
          <br />
          {{ lang.AM1008 }}
        </button>
      </div>
    </div>
    <div class="panel-body paging__panel-body">
      <div class="col-lg-7">
        <!-- Searchbar - triggered by enter key -->
        <div class="form-group searchbar__form-group">
          <input
            type="text"
            class="form-control"
            id="inputSearch"
            :placeholder="lang.AM1001"
            v-model="searchString"
            @keyup.enter="emitUserSearch()"
          />
        </div>
      </div>
      <div class="col-lg-5">
        <ul class="pagination btn-group">
          <li>
            <a
              role="button"
              class="dropdown-toggle"
              data-toggle="dropdown"
              id="elementsPerPageDropdown"
            >
              <i class="material-icons md-18">view_headline</i>
            </a>
            <b-tooltip
              ref="tooltip"
              target="elementsPerPageDropdown"
              :delay="globals.tooltipDelay"
              >{{ lang.AM1004 }}</b-tooltip
            >
            <ul class="dropdown-menu">
              <!-- Add dropdown entries here -->
              <li>
                <a
                  role="button"
                  @click="changePageSize(1, 20)"
                  class="dropdown-element"
                  v-bind:class="{ 'dropdown-active': pageSize === 20 }"
                  >20</a
                >
              </li>
              <li>
                <a
                  role="button"
                  @click="changePageSize(1, 50)"
                  class="dropdown-element"
                  v-bind:class="{ 'dropdown-active': pageSize === 50 }"
                  >50</a
                >
              </li>
              <li>
                <a
                  role="button"
                  @click="changePageSize(1, 100)"
                  class="dropdown-element"
                  v-bind:class="{ 'dropdown-active': pageSize === 100 }"
                  >100</a
                >
              </li>
              <li>
                <a
                  role="button"
                  @click="changePageSize(1, 200)"
                  class="dropdown-element"
                  v-bind:class="{ 'dropdown-active': pageSize === 200 }"
                  >200</a
                >
              </li>
              <li>
                <a
                  role="button"
                  @click="changePageSize(1, -1)"
                  class="dropdown-element"
                  v-bind:class="{
                    'dropdown-active': pageSize === tableElementCount,
                  }"
                  >{{ lang.AM1005 }}</a
                >
              </li>
            </ul>
          </li>
          <li
            v-bind:class="{
              disabled: !pageNumbers.length || currentPage === 1,
            }"
          >
            <a role="button" id="firstPageButton" @click="selectPage(1)">
              <i class="material-icons md-18">first_page</i>
            </a>
            <b-tooltip
              ref="tooltip"
              target="firstPageButton"
              :delay="globals.tooltipDelay"
              >{{ lang.AM1006 }}</b-tooltip
            >
          </li>
          <li v-if="pageNumbers.length > 5 && currentPage > 3" class="disabled">
            <a role="button">...</a>
          </li>
          <!-- Pagenumbers -->
          <li
            v-for="pageNumber in showPages"
            :key="pageNumber"
            v-bind:class="{ active: currentPage === pageNumber }"
          >
            <a role="button" @click="selectPage(pageNumber)">{{
              pageNumber
            }}</a>
          </li>
          <li
            v-if="
              pageNumbers.length > 5 && currentPage < pageNumbers.length - 2
            "
            class="disabled"
          >
            <a role="button">...</a>
          </li>
          <li
            v-bind:class="{
              disabled:
                !pageNumbers.length || currentPage === pageNumbers.length,
            }"
          >
            <a
              role="button"
              id="lastPageButton"
              @click="selectPage(pageNumbers.length)"
            >
              <i class="material-icons md-18">last_page</i>
            </a>
            <b-tooltip
              ref="tooltip"
              target="lastPageButton"
              :delay="globals.tooltipDelay"
              >{{ lang.AM1007 }}</b-tooltip
            >
          </li>
          <li class="disabled">
            <a role="button" id="agenciesTotalElementsCounter">{{
              tableElementCount
            }}</a>
            <b-tooltip
              ref="tooltip"
              target="agenciesTotalElementsCounter"
              :delay="globals.tooltipDelay"
              >{{ lang.AM1009 }}</b-tooltip
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgencyManagementToolbar",
  props: ["tableElementCount", "agencySelected", "refreshEnabled"],
  data() {
    return {
      lang: {
        AM1000: "Aktualisieren",
        AM1001: "Suche ...",
        AM1002: "Neue Agentur",
        AM1003: "Bearbeiten",
        AM1004: "Elemente pro Seite",
        AM1005: "Alle",
        AM1006: "Erste Seite",
        AM1007: "Letzte Seite",
        AM1008: "Löschen",
        AM1009: "Total agencies count",
      },
      searchString: "",
      pageSize: 20,
      currentPage: 1,
      pageNumbers: [],
      showPages: [],
    };
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },
  methods: {
    // Emit functions
    emitUserSearch() {
      this.$emit("searchTextChanged", this.searchString);
    },
    emitChangePageNumber() {
      this.$emit("pageNumberChanged", this.currentPage);
    },
    emitChangePageSize() {
      this.$emit("pageSizeChanged", this.pageSize);
    },
    emitEditAgency(addMode) {
      this.$emit("openEditAgency", addMode);
    },
    emitDeleteAgency() {
      this.$emit("openDeleteAgency");
    },
    emitTriggerReload() {
      this.$emit("onTriggerReload");
    },
    // Markup functions
    changePageSize(pageNumber, pageSize) {
      this.selectPage(pageNumber);
      this.pageSize = pageSize === -1 ? this.tableElementCount : pageSize;
      this.emitChangePageSize();
      this.pageCount();
      this.getPageingObject();
    },
    selectPage(pageNumber) {
      this.currentPage = pageNumber || 1;
      this.emitChangePageNumber();
      this.getPageingObject();
    },
    pageCount() {
      this.pageNumbers = [];
      let pages = this.tableElementCount
        ? Math.ceil(this.tableElementCount / this.pageSize)
        : 0;
      for (let i = 1; i <= pages; i++) {
        this.pageNumbers.push(i);
      }
    },
    getPageingObject() {
      if (this.currentPage < 4) {
        this.showPages = this.pageNumbers.slice(0, 5);
        return;
      }

      let outOfIndex = this.currentPage + 2 > this.pageNumbers.length;

      let startIndex = outOfIndex
        ? this.pageNumbers.length - 5
        : this.currentPage - 3;

      let endIndex = outOfIndex
        ? this.pageNumbers.length
        : this.currentPage + 2;

      // for cases where there are only 4 pages
      if(startIndex < 0) {
        startIndex = 0;
      }

      this.showPages = this.pageNumbers.slice(startIndex, endIndex);
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    tableElementCount() {
      this.pageCount();
      this.getPageingObject();
    },
  },
};
</script>

<style scoped>
.paging__panel-body,
.menu__panel-body {
  padding: 5px 0 0 0;
}

.searchbar__form-group {
  margin: 10px 0 0 0;
}

.button__toolbar {
  width: 120px;
  height: 80px;
  margin: 8px 8px 0 8px;
  padding: 0px;
  font-size: 12px;
  white-space: normal;
  background-color: lightgrey;
}
</style>



// WEBPACK FOOTER //
// AgencyManagementToolbar.vue?7989783e